<script>
	import Helper from '../../Classes/Helper';
	import Menu from '../../Stores/Menu';
	import Next from '../../Stores/Next';
	import Product from '../../Stores/Product';

	function setProperty(property) {
		$Product.step.description_active = false;
		$Menu.open = false;

		Next.setCancel();
		Product.setProperty(property);
	}

	function setGroup(group) {
		$Product.step.description_active = false;
		$Menu.open = false;

		Next.setCancel();
		Product.setGroup(group);
	}

	function setDescription() {
		$Product.step.description_active = true;
		$Product.property.active = false;
		$Product.group.active = false;
		$Menu.open = false;
	}

	function getName(property) {
		let name = '';
		switch (property.property_type) {
			case 'options': name = property.name; break;
			default: name = property.group || property.name; break;
		}

		return name;
	}
</script>

<style>
	/* Title */

	div.zes-groups-title {
		display: flex;
		padding: .15em 1.25em .75em 1.25em;
		margin-bottom: .8em;
	}

	div.zes-groups-title > div:nth-child(1) {
		flex-grow: 1;
	}

	div.zes-groups-title > div:nth-child(1) div {
		font-size: 2.25em;
		font-weight: 400;
		color: var(--zes-1-1);
	}

	div.zes-groups-title > div:nth-child(1) span {
		font-size: .75em;
		font-weight: 300;
		color: var(--zes-3-1);
		display: block;
	}

	div.zes-groups-title > div:nth-child(1) span b {
		font-weight: 500;
		padding: 0 .5em;
		border-radius: .25em;
		background: hsl(0deg 0% 95%);
	}

	div.zes-groups-title > div:nth-child(2) {
		padding-top: 1em;
		padding-left: 2em;
		display: none;
	}

	div.zes-groups-title > div:nth-child(2) i {
		font-size: 1.75em;
		color: var(--zes-1-2);
	}

	/* Group */

	div.zes-groups-steps {
		flex-grow: 1;
	}

	div.zes-groups-steps > div.zes-active {
		background: var(--zes-1-4);
	}

	div.zes-groups-group {
		display: flex;
		padding: .75em 1em .75em 1.25em;
		border-bottom: 1px solid hsl(206deg 75% 85% / .5);
		cursor: pointer;
	}

	div.zes-groups-group:hover {
		background: hsl(0deg 0% 0% / .025);
	}

	div.zes-groups-group > div > i {
		color: var(--zes-3-2);
		margin-top: .15em;
		margin-right: 1em;
	}

	div.zes-groups-group div div {
		font-size: .95em;
		font-weight: 700;
		color: var(--zes-3-1);
	}

	div.zes-groups-steps > div.zes-active div {
		color: var(--zes-1-2);
	}

	div.zes-groups-steps > div.zes-active > div > i {
		color: var(--zes-1-3);
	}

	div.zes-groups-group div span:empty {
		display: none;
	}

	div.zes-groups-group div span {
		font-size: .85em;
		font-weight: 600;
		margin-top: .25em;
		color: var(--zes-1-3);
	}

	div.zes-groups-group div span i {
		margin-right: .25em;
		opacity: .5;
	}

	div.zes-groups-group.zes-success *:not(span) {
		color: var(--zes-2-1) !important;
	}

	div.zes-groups-group.zes-success span {
		color: var(--zes-2-2) !important;
	}

	div.zes-groups-group.zes-error *:not(span) {
		color: var(--zes-4-1) !important;
	}

	div.zes-groups-group.zes-error span {
		color: var(--zes-4-2) !important;
	}

	/* Menu */

	div.zes-groups-menu {
		margin-left: 2.5em;
		cursor: pointer;
	}

	div.zes-groups-menu:empty {
		display: none;
	}

	div.zes-groups-menu div {
		font-size: .85em;
		font-weight: 600;
		color: var(--zes-3-1);
		padding: .6em 1.5em .6em .75em;
		border-bottom: 1px solid hsl(206deg 75% 85% / .5);
		border-left: 2px solid transparent;
		position: relative;
	}

	div.zes-groups-menu div:hover {
		background: hsl(0deg 0% 0% / .025);
		border-left: 2px solid var(--zes-3-2);
	}

	div.zes-groups-menu div span {
		font-size: .7em;
		font-weight: 600;
		text-transform: uppercase;
		color: #FFF;
		padding: .25em .75em;
		margin-left: 1em;
		background: var(--zes-1-2);
		border-radius: .5em;
		display: inline-block;
		box-shadow: 0 0 .5em 0 var(--zes-1-3);
		position: absolute;
	}

	div.zes-groups-menu div i {
		position: absolute;
		padding-top: .4em;
		right: .5em;
	}

	div.zes-groups-menu div.zes-active {
		font-weight: 600;
		color: var(--zes-1-2);
		border-left: 2px solid var(--zes-1-3);
		background: hsl(206deg 75% 44% / .025);
	}

	/* Responsive */

	@media only screen and (max-width: 1024px) and (orientation: portrait) {
		div.zes-groups {
			flex-grow: 1;
			padding-top: 1em;
			border-right: none;
			background-size: 130%, 100%;
		}

		div.zes-groups-title > div:nth-child(2) {
			display: block;
		}
	}
</style>

{#if Helper.is($Product.step)}
	<div class="zes-groups-title">
		<div>
			<div>{$Product.step.name}</div>
		</div>
		<div on:click="{event => $Menu.open = false}">
			<i class="fa-solid fa-xmark-large"></i>
		</div>
	</div>
	<div class="zes-groups-steps">
		{#each $Product.step.properties as property, index}
			{#if Product.menuVisibleProperty(property)}
				<div on:click="{event => setProperty(property)}" class="zes-groups-group zes-{property.selected.state}" class:zes-active="{property.active}">
					<div>
						{#if Helper.is(property.selected)}
							<i class="fa-light fa-circle-{property.selected.valid ? 'check' : 'x'}"></i>
						{:else}
							<i class="fa-light fa-circle-{property.active ? 'ellipsis' : 'question'}"></i>
						{/if}
					</div>
					<div>
						<div>{Product.getPropertyName(property)}</div>
						{#if property.selected && property.selected.label}
							<span>
								<i class="fa-regular fa-{property.selected.valid ? 'check' : 'xmark'}"></i>
								{property.selected.label}
							</span>
						{/if}
					</div>
				</div>
				{#if property.active && property.groups}
					<div class="zes-groups-menu">
						{#each property.groups as group, counter}
							{#if Product.menuVisibleGroup(property, group)}
								<div on:click="{event => setGroup(group)}" class:zes-active="{group.active}">
									{group.name}
									{#if group.badge}
										<span>{group.badge}</span>
									{/if}
									<i class="fa-light fa-angle-right"></i>
								</div>
							{/if}
						{/each}
					</div>
				{/if}
			{/if}
		{/each}

		{#if Helper.is($Product.step.description, $Product.step.description_right)}
			<div on:click="{event => setDescription()}" class="zes-groups-group" class:zes-active="{$Product.step.description_active}">
				<div>
					<i class="fa-light fa-circle-info"></i>
				</div>
				<div>
					<div>Hulp</div>
				</div>
			</div>
		{/if}
	</div>
{/if}